export default __webpack_public_path__ + "static/media/ZingPC.0845c864.png";